import { createCopyKey } from '../../../../shared/utils/createCopyKey';

export const ANCHORS_BAR_COPY_PREFIX = 'logged_out_homepage.sandbox.anchors';

export const getCopyKey = createCopyKey(ANCHORS_BAR_COPY_PREFIX);

export const ANCHORS_BAR_HEIGHT = '66px';

// The production header's height (65px, 86px from md). The bar is fixed right under it.
export const HEADER_HEIGHT_DEFAULT = '65px';
export const HEADER_HEIGHT_MD = '86px';

export const ANCHORS_BAR_SELECTOR = '[data-anchors-bar]';
